import { POST_MVP_DASHBOARD } from '@ui/utils/constants';
import type { ReactNode } from 'react';

const PostMvp = ({ children }: { children: ReactNode }) => {
  return POST_MVP_DASHBOARD ? <>{children}</> : null;
};

export default PostMvp;
